module.exports = __webpack_public_path__ + "static/Q1Answer_wishmasflower_wishmastree-f70c1bc91be3ae53bb7a112a9c001ffd.jpg";